jQuery(document).ready(function () {

  jQuery(document).on('click','.button-sample',function(e) {
    e.preventDefault();
    setTimeout(function(){
      jQuery('#add-sample-button').click();
    }, 150);
           $(this).toggleClass('sample__button--already-in-cart');
        $(this).text("Added to cart");
  });

          $('.sample__button--add').click(function(){
       $(this).toggleClass('sample__button--already-in-cart');
        $(this).text("Added to cart");
    });


  jQuery(document).one('click','.sample__button--add',function(e) {
    e.preventDefault();
    if (Number(jQuery('.site-header-cart--count').attr('data-header-cart-count')) < 1) {
      jQuery('.site-header-cart--count').attr('data-header-cart-count', 1);
      jQuery('.site-header-cart--count').css('opacity', 1);
    } else {
      jQuery('.site-header-cart--count').attr('data-header-cart-count', Number(jQuery('.site-header-cart--count').attr('data-header-cart-count')) + 1);
    }
    jQuery('.sample__modal--overlay').fadeIn();
    setTimeout(function(){
      jQuery('.sample__modal--overlay').fadeOut();
    }, 3000);
  });

  jQuery(document).on('click','.sample__modal--overlay',function(e) {
    e.preventDefault();
    jQuery(this).fadeOut();
  });

  jQuery(document).one('click','.button__quickshop--open',function(e) {
    e.preventDefault();
    jQuery('.quickshop__modal--overlay').remove();
    jQuery('body').prepend('<div class="quickshop__modal--overlay"><div class="quickshop__modal--inner"><div class="quickshop__modal--close">✕</div></div></div>');
    jQuery('.quickshop__modal--overlay').fadeIn();
    jQuery.get(jQuery(this).attr('data-product-url'), function(data){
      jQuery('.quickshop__modal--inner').append(data);
    });
  });

  jQuery(document).on('click','.quickshop__modal--overlay, .quickshop__modal--close',function(e) {
    if(e.target == this) {
      jQuery('.quickshop__modal--overlay').fadeOut();
      setTimeout(function(){
        jQuery('.quickshop__modal--overlay').remove();
      }, 600);
    } 
  });
  
  jQuery('.product-info__accordion--item').click(function() {
    if (jQuery('.product-info__accordion--trigger', this).hasClass('active')) {
      jQuery('.product-info__accordion--panel', this).slideUp();
      jQuery('.product-info__accordion--trigger').removeClass('active');
    } else {
      jQuery('.product-info__accordion--trigger').removeClass('active');
      jQuery('.product-info__accordion--panel').slideUp();
      jQuery('.product-info__accordion--trigger', this).addClass('active');
      jQuery('.product-info__accordion--panel', this).slideDown();
    }
  });
  
});
